import React from 'react';

import styles from './label.module.css';

export const Label = ({ children, className = '', required = false, htmlFor }) => {
  return <label className={`${styles.label} ${className}`} htmlFor={htmlFor}>{children} {required && <RequiredMarker />}</label>;
};

export const RequiredMarker = () => {
  return <span className={styles.requiredMarker}>*</span>;
};

